import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { MatDialogRef, MatDialog } from "@angular/material";
import { ReasonComponent } from "../reason/reason.component";
import { PaymentDetailsComponent } from "../payment/payment-initiate/payment-details/payment-details.component";
@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(private _http: HttpClient, private dialog: MatDialog) {}

  getRequest(url) {
    let fullUrl = environment.base_url + url;
    // this._loaderService.show();

    return this._http.get(fullUrl).pipe(
      map((response: any) => {
        // this._loaderService.show();
        if (response) {
          // this._loaderService.hide();
          return response;
        } else {
          // this._loaderService.hide();
          return {};
        }
      })
    );
  }
  PutRequest(data, url) {
    let fullUrl = environment.base_url + url;

    return this._http.put(fullUrl, data).pipe(
      map((response: any) => {
        // this._loaderService.show();
        if (response) {
          // this._loaderService.hide();
          return response;
        } else {
          // this._loaderService.hide();
          return {};
        }
      })
    );
  }

  PostRequest(data, url) {
    let fullUrl = environment.base_url + url;

    return this._http.post(fullUrl, data).pipe(
      map((response: any) => {
        if (response) {
          return response;
        } else {
          return {};
        }
      })
    );
  }
  public Reasonvalue(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<ReasonComponent>;

    dialogRef = this.dialog.open(ReasonComponent, {
      disableClose: true,
      width: "500px",
      maxWidth: "600px",
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
  postFile(files: File, url): Observable<any> {
    let formData = new FormData();
    let fullurl = environment.base_url + url;
    formData.append("file", files);
    let request = {
      headers: new HttpHeaders({
        "Content-Type": "multipart/form-data",
      }),
    };

    return this._http.post(fullurl, formData, request);
  }
}
